import React, { PureComponent } from 'react';

import {
    CRow,
    CCol,
    CButton,
    CLink,
    CPopover,
    CTooltip
} from '@coreui/react';

import CIcon from '@coreui/icons-react';

import { helps } from 'src/_helpers';

import { ThePermission }
from 'src/containers/ThePermission';

import { ChecksFormContainer }
from 'src/containers/checks';

import CheckHistoryRow
from './CheckHistoryRow';

class EmployeeRow extends PureComponent {

    getChecks() {

        const {
            employeeData,
            externalCheck
        } = this.props;

        if (externalCheck) {
            return [externalCheck];
        }

        return (
            employeeData?.checks || []
        );
    }

    getEmployee() {

        const {
            employeeData,
            employee
        } = this.props;

        return (
            employee ||
            employeeData?.employee
        );
    }

    getPosition() {

        const {
            employeeData
        } = this.props;

        return (
            employeeData?.position || {}
        );
    }

    getDefaultShift() {

        const position =
            this.getPosition();

        const {
            employeeData
        } = this.props;

        if (
            !position ||
            !position.shifts
        ) {
            return {};
        }

        return (
            position.shifts.find(
                shift =>
                    shift.id ===
                    employeeData?.shift_id
            ) || {}
        );
    }

    /**
     * Có ca đang mở không?
     * checked_out = 0
     */
    hasOpenedCheck() {
        const checks = this.getChecks();
        return checks.some(
            check =>
                Number(
                    check.checked_out
                ) === 0
        );
    }

    /**
     * Bản ghi đang mở
     */
    getOpenedCheck() {
        const checks = this.getChecks();

        return (
            checks.find(
                check =>
                    Number(
                        check.checked_out
                    ) === 0
            ) || null
        );
    }

    renderPosition() {

        const position =
            this.getPosition();

        const defaultShift =
            this.getDefaultShift();

        if (
            helps.isEmpty(position)
        ) {
            return null;
        }

        return (

            <div className="text-muted">

                <span>

                    <small>
                        <i>
                            Vị Trí:
                        </i>
                    </small>

                    {' '}

                    <b>
                        {position.name}
                    </b>

                    {
                        position.description &&
                        <>
                            {' - '}
                            {position.description}
                        </>
                    }

                </span>

                {
                    !helps.isEmpty(
                        defaultShift
                    ) &&
                    (
                        <div>

                            <small>
                                <i>
                                    Ca:
                                </i>
                            </small>

                            {' '}

                            <b>
                                {
                                    defaultShift.label
                                }
                            </b>

                            {' - '}

                            <b>

                                {
                                    defaultShift.start
                                }

                                {' - '}

                                {
                                    defaultShift.end
                                }

                                {' ('}

                                {
                                    defaultShift.duration
                                }

                                {'/24)'}

                            </b>

                        </div>
                    )
                }

            </div>

        );
    }

    renderCheckInButton() {

        const {
            project,
            curent_date,
            show_forms,
            toggleForm
        } = this.props;

        const employee =
            this.getEmployee();

        const position =
            this.getPosition();

        const defaultShift =
            this.getDefaultShift();

        const formId =
            `${employee.employee_id}-false`;

        return (

            <ThePermission
                {...this.props}
                component="projects"
                action="edit"
            >

                <CTooltip
                    content={
                        `Check-in: ${employee.fullname}`
                    }
                >

                    <CButton
                        color="primary"
                        onClick={() =>
                            toggleForm(formId)
                        }
                    >

                        <CIcon
                            name="cil-check-circle"
                        />

                        {' '}

                        Check-in

                    </CButton>

                </CTooltip>

                <ChecksFormContainer

                    key={
                        `checkin-${employee.employee_id}`
                    }

                    {...this.props}

                    action="checkin"

                    is_overtime={false}

                    curent_date={
                        curent_date
                    }

                    default_shift={
                        defaultShift
                    }

                    default_position={
                        position
                    }

                    employee={
                        employee
                    }

                    position={
                        position
                    }

                    project={
                        project
                    }

                    check={{}}

                    show_forms={
                        show_forms
                    }

                    toggleForm={
                        toggleForm
                    }

                />

            </ThePermission>

        );
    }

    renderOvertimeButton() {

        const {
            project,
            curent_date,
            show_forms,
            toggleForm
        } = this.props;

        const employee =
            this.getEmployee();

        const position =
            this.getPosition();

        const defaultShift =
            this.getDefaultShift();

        const formId =
            `${employee.employee_id}-true`;

        return (

            <ThePermission
                {...this.props}
                component="projects"
                action="edit"
            >

                <CTooltip
                    content={
                        `Tăng ca: ${employee.fullname}`
                    }
                >

                    <CButton
                        color="warning"
                        size="sm"
                        className="mt-2"
                        onClick={() =>
                            toggleForm(formId)
                        }
                    >

                        <CIcon
                            name="cil-plus"
                        />

                        {' '}

                        Tăng Ca

                    </CButton>

                </CTooltip>

                <ChecksFormContainer

                    key={
                        `overtime-${employee.employee_id}`
                    }

                    {...this.props}

                    action="checkin"

                    is_overtime={true}

                    curent_date={
                        curent_date
                    }

                    default_shift={
                        defaultShift
                    }

                    default_position={
                        position
                    }

                    employee={
                        employee
                    }

                    position={
                        position
                    }

                    project={
                        project
                    }

                    check={{}}

                    show_forms={
                        show_forms
                    }

                    toggleForm={
                        toggleForm
                    }

                />

            </ThePermission>

        );
    }

    render() {

        const {
            history,
            rowIndex = 0
        } = this.props;

        const employee =
            this.getEmployee();

        if (!employee) {
            return null;
        }

        const checks =
            this.getChecks();

        const hasOpenedCheck =
            this.hasOpenedCheck();

        return (

            <tr>

                <td
                    style={{
                        width: '30%'
                    }}
                >

                    <CPopover
                        content={
                            employee.fullname
                        }
                    >

                        <CLink
                            className="text-dark"
                            onClick={() =>
                                history.push(
                                    `/employees/view/${employee.employee_id}`
                                )
                            }
                        >

                            <span className="mr-1">
                                {rowIndex + 1}.
                            </span>

                            <b
                                style={{
                                    fontSize:
                                        '16px'
                                }}
                            >
                                {
                                    employee.fullname
                                }
                            </b>

                            {' ('}

                            {
                                employee.employee_id
                            }

                            {')'}

                        </CLink>

                    </CPopover>

                    {
                        this.renderPosition()
                    }

                </td>

                <td>

                    {
                        checks.map(
                            check => (

                                <CheckHistoryRow

                                    key={
                                        check.id
                                    }

                                    {...this.props}

                                    check={
                                        check
                                    }

                                    employeeData={
                                        this.props
                                            .employeeData
                                    }

                                />

                            )
                        )
                    }

                    {
                        !hasOpenedCheck &&
                        this.renderCheckInButton()
                    }

                    {
                        this.renderOvertimeButton()
                    }

                </td>

            </tr>

        );
    }
}

export default EmployeeRow;